var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpringBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29423_6777)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#F5CDC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5332 2.77451C25.5332 2.77451 12.6896 19.9146 15.9522 23.9124C19.2148 27.9102 25.5332 2.77451 25.5332 2.77451Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9405 23.901C15.9405 23.901 23.3732 11.1149 25.5215 2.76312C25.5215 2.76312 19.2031 27.8988 15.9405 23.901Z",
    fill: "#417F51"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3253 1.35047C27.3253 1.35047 9.36957 13.0337 11.0698 17.9046C12.77 22.7755 27.3253 1.35047 27.3253 1.35047Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.058 17.9161C11.058 17.9161 22.4426 8.46154 27.3135 1.36197C27.3135 1.36197 12.7467 22.7985 11.058 17.9161Z",
    fill: "#417F51"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5811 16.5755C33.5811 16.5755 40.5961 35.8859 49.8714 44.7912",
    stroke: "#417F51",
    strokeWidth: 0.264298,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8774 41.5273C46.8774 41.5273 53.2324 54.5047 56.6117 53.7744C60.0118 53.0321 46.8774 41.5273 46.8774 41.5273Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6327 53.7624C56.6327 53.7624 51.2309 45.3673 46.8984 41.5153C46.8984 41.5153 60.0448 53.0409 56.6327 53.7624Z",
    fill: "#417F51"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5938 37.2342C43.5938 37.2342 54.315 46.9139 57.212 44.9638C60.109 43.0138 43.5938 37.2342 43.5938 37.2342Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2003 44.943C57.2003 44.943 49.0714 39.1767 43.582 37.2133C43.582 37.2133 60.0765 43.005 57.2003 44.943Z",
    fill: "#417F51"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6738 31.9842C40.6738 31.9842 51.3951 41.6639 54.2921 39.7138C57.1891 37.7638 40.6738 31.9842 40.6738 31.9842Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2599 39.7061C54.2599 39.7061 46.131 33.9398 40.6416 31.9765C40.6416 31.9765 57.1361 37.7681 54.2599 39.7061Z",
    fill: "#417F51"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5967 19.1525C34.5967 19.1525 47.8433 31.0919 51.4237 28.6918C54.9922 26.2709 34.6175 19.1405 34.6175 19.1405L34.5967 19.1525Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4234 28.6918C51.4234 28.6918 41.3722 21.5661 34.6172 19.1405C34.6172 19.1405 55.0039 26.2917 51.4234 28.6918Z",
    fill: "#417F51"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7607 19.1954C34.7607 19.1954 27.9469 35.6975 31.4153 38.245C34.8837 40.7925 34.7607 19.1954 34.7607 19.1954Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4153 38.245C31.4153 38.245 34.751 26.3867 34.7607 19.1954C34.7607 19.1954 34.8837 40.7925 31.4153 38.245Z",
    fill: "#417F51"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3847 25.6153C37.3847 25.6153 30.5709 42.1173 34.0393 44.6649C37.5077 47.2124 37.3847 25.6153 37.3847 25.6153Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0393 44.665C34.0393 44.665 37.375 32.8068 37.3847 25.6155C37.3847 25.6155 37.5077 47.2126 34.0393 44.665Z",
    fill: "#417F51"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2091 29.1118C39.2091 29.1118 35.9345 46.6501 39.8525 48.4386C43.7705 50.2272 39.2091 29.1118 39.2091 29.1118Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8528 48.4385C39.8528 48.4385 40.6862 36.1384 39.2095 29.1117C39.2095 29.1117 43.7709 50.2271 39.8528 48.4385Z",
    fill: "#417F51"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.589 35.0127C42.589 35.0127 41.5597 52.836 45.672 54.0962C49.7844 55.3564 42.589 35.0127 42.589 35.0127Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6719 54.0962C45.6719 54.0962 44.9435 41.7822 42.5888 35.0127C42.5888 35.0127 49.7754 55.3892 45.6719 54.0962Z",
    fill: "#417F51"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7059 39.7876C45.7059 39.7876 47.5239 55.1902 51.2334 55.6564C54.9428 56.1227 45.7059 39.7876 45.7059 39.7876Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2338 55.6563C51.2338 55.6563 48.7466 45.2456 45.7063 39.7874C45.7063 39.7874 54.9432 56.1226 51.2338 55.6563Z",
    fill: "#417F51"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1768 25.0133C37.1768 25.0133 52.6885 39.0019 56.8692 36.1998C61.0379 33.3768 37.1768 25.0133 37.1768 25.0133Z",
    fill: "#417F51"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.836 36.1921C56.836 36.1921 45.0746 27.8343 37.1436 25.0056C37.1436 25.0056 61.0047 33.3691 56.836 36.1921Z",
    fill: "#417F51"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24301 -3.30096C4.24301 -3.30096 0.428467 2.86724 1.61882 8.41321C2.80918 13.9862 6.67782 5.95134 4.24301 -3.30096Z",
    fill: "#FF8FA2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21609 -2.86691C4.21609 -2.86691 2.21413 5.03271 5.35233 10.5787C8.49054 16.1517 9.95144 6.22307 4.21609 -2.86691Z",
    fill: "#F96982"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51367 -2.70502C4.51367 -2.70502 5.8393 5.32988 10.9524 9.17148C16.0655 13.0131 13.4143 3.35497 4.51367 -2.70502Z",
    fill: "#FF8FA2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35156 -2.59708C4.35156 -2.59708 8.76128 4.24746 14.9565 5.76246C21.1788 7.2504 14.9024 -0.568062 4.35156 -2.59708Z",
    fill: "#F96982"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21609 -2.86691C4.21609 -2.86691 2.21413 5.03271 5.35233 10.5787C8.49054 16.1517 9.95144 6.22307 4.21609 -2.86691Z",
    fill: "#FFCCD4"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35156 -2.59708C4.35156 -2.59708 8.76128 4.24746 14.9565 5.76246C21.1788 7.2504 14.9024 -0.568062 4.35156 -2.59708Z",
    fill: "#FFCCD4"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43038 0.134773C2.43038 0.134773 5.86617 0.621737 7.75991 -1.73192L6.51546 -2.57058C5.46037 -3.27397 4.64876 -4.302 4.18885 -5.49236L4.13474 -5.68173C4.02653 -6.00638 3.64778 -6.1687 3.35019 -6.03343C3.0526 -5.92521 2.91734 -5.60057 2.9985 -5.30298C3.32314 -4.22084 3.32314 -3.05754 2.9985 -1.94835L2.40332 0.10772L2.43038 0.134773Z",
    fill: "#417F51"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0295 18.1099C45.0295 18.1099 54.8199 19.882 56.011 16.2796C57.2312 12.6773 53.6288 11.4571 53.6288 11.4571C53.6288 11.4571 56.9697 9.36537 55.9529 7.53512C54.907 5.67582 50.1135 7.70943 50.1135 7.70943C50.1135 7.70943 51.4208 6.08254 49.8521 4.77522C45.2329 0.969461 37.7666 18.2261 37.7666 18.2261L45.0585 18.1099H45.0295Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5842 11.2232C40.5842 11.2232 44.3319 2.01388 41.0491 0.0964785C37.7662 -1.82093 35.8488 1.4619 35.8488 1.4619C35.8488 1.4619 34.5124 -2.22765 32.4788 -1.61757C30.4452 -0.978431 31.462 4.13465 31.462 4.13465C31.462 4.13465 30.1547 2.50776 28.5569 3.78603C23.9086 7.53368 39.2478 18.399 39.2478 18.399L40.6133 11.2232H40.5842Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2465 13.4019C32.2465 13.4019 24.5188 7.15585 21.7298 9.74144C18.9409 12.327 21.5265 15.116 21.5265 15.116C21.5265 15.116 17.6045 15.3193 17.6045 17.4401C17.6045 19.5609 22.8047 20.0838 22.8047 20.0838C22.8047 20.0838 20.9745 20.8101 21.6427 22.7856C23.2405 27.521 38.725 16.801 38.725 16.801L32.2755 13.4019H32.2465Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0244 18.1371C43.0244 18.1371 50.113 19.4154 50.9846 16.8007C51.8561 14.1861 49.2415 13.3146 49.2415 13.3146C49.2415 13.3146 51.6818 11.8039 50.9265 10.4675C50.1711 9.13113 46.6849 10.5837 46.6849 10.5837C46.6849 10.5837 47.6437 9.42164 46.4816 8.46294C43.1407 5.70304 37.708 18.2243 37.708 18.2243L42.9954 18.1371H43.0244Z",
    fill: "#E7E7E7"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2934 12.6756C40.2934 12.6756 43.2857 5.3255 40.6711 3.81482C38.0564 2.30414 36.5167 4.88973 36.5167 4.88973C36.5167 4.88973 35.4418 1.92646 33.8149 2.44939C32.188 2.94327 33.0014 7.03954 33.0014 7.03954C33.0014 7.03954 31.9556 5.73222 30.6773 6.77808C26.9587 9.77039 39.1894 18.4278 39.1894 18.4278L40.2934 12.7046V12.6756Z",
    fill: "#E7E7E7"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9602 14.3015C33.9602 14.3015 28.2661 9.71136 26.2325 11.5997C24.1989 13.4881 26.0873 15.5507 26.0873 15.5507C26.0873 15.5507 23.1821 15.696 23.2112 17.2648C23.2112 18.8336 27.046 19.2112 27.046 19.2112C27.046 19.2112 25.7096 19.7632 26.1744 21.1867C27.3365 24.6729 38.7247 16.7709 38.7247 16.7709L33.9893 14.2725L33.9602 14.3015Z",
    fill: "#E7E7E7"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8581 24.2095C39.8581 24.2095 40.0324 34.1451 43.7801 34.639C47.5568 35.1329 48.0506 31.3562 48.0506 31.3562C48.0506 31.3562 50.7524 34.2323 52.3503 32.8668C53.9481 31.5014 51.043 27.1727 51.043 27.1727C51.043 27.1727 52.8732 28.1605 53.861 26.3302C56.679 21.0719 38.3184 17.0918 38.3184 17.0918L39.8581 24.2095Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1586 21.6808C29.7183 23.0172 23.0074 25.5447 23.9661 29.2343C24.9248 32.9238 28.6143 31.936 28.6143 31.936C28.6143 31.936 26.9584 35.5094 28.8467 36.4971C30.7351 37.4849 33.6403 33.1562 33.6403 33.1562C33.6403 33.1562 33.4078 35.2189 35.4705 35.4513C41.397 36.0904 38.2304 17.5846 38.2304 17.5846C38.2304 17.5846 33.8146 20.8093 32.1877 21.6808H32.1586Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4802 22.5245C39.4802 22.5245 39.5964 30.1069 42.4725 30.4846C45.3486 30.8623 45.7263 27.9862 45.7263 27.9862C45.7263 27.9862 47.7889 30.1941 49.0091 29.1482C50.2293 28.1024 48.0213 24.7905 48.0213 24.7905C48.0213 24.7905 49.4158 25.5458 50.1712 24.1514C52.321 20.1422 38.2891 17.0918 38.2891 17.0918L39.4802 22.5245Z",
    fill: "#E7E7E7"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9019 20.4906C32.1588 21.4493 27.3944 23.2505 28.0916 25.8652C28.7888 28.4798 31.3745 27.7826 31.3745 27.7826C31.3745 27.7826 30.1833 30.31 31.5197 31.0073C32.8561 31.7045 34.9187 28.6251 34.9187 28.6251C34.9187 28.6251 34.7735 30.1067 36.2261 30.2519C40.4385 30.7168 38.1725 17.5564 38.1725 17.5564C38.1725 17.5564 35.0349 19.8515 33.9019 20.4616V20.4906Z",
    fill: "#E7E7E7"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4605 27.0856L38.5508 17.0918L47.2372 23.5413",
    stroke: "white",
    strokeWidth: 0.232413,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1328 17.4396L37.3009 17.0329L29.3407 14.3021",
    stroke: "white",
    strokeWidth: 0.232413,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8857 8.98627L37.6793 18.7767L36.6624 6.7493",
    stroke: "white",
    strokeWidth: 0.232413,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2245 15.6404L39.5381 16.3958L45.7842 11.1956",
    stroke: "white",
    strokeWidth: 0.232413,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7812 25.8646L38.5503 15.8999L36.8943 26.7652",
    stroke: "white",
    strokeWidth: 0.232413,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5503 21.7709C41.1335 21.7709 43.2277 19.6768 43.2277 17.0936C43.2277 14.5104 41.1335 12.4163 38.5503 12.4163C35.9671 12.4163 33.873 14.5104 33.873 17.0936C33.873 19.6768 35.9671 21.7709 38.5503 21.7709Z",
    fill: "#F19D06"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5501 20.6382C40.5076 20.6382 42.0944 19.0513 42.0944 17.0939C42.0944 15.1364 40.5076 13.5496 38.5501 13.5496C36.5927 13.5496 35.0059 15.1364 35.0059 17.0939C35.0059 19.0513 36.5927 20.6382 38.5501 20.6382Z",
    fill: "#F19D06"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5507 19.3005C39.7701 19.3005 40.7586 18.312 40.7586 17.0926C40.7586 15.8732 39.7701 14.8846 38.5507 14.8846C37.3313 14.8846 36.3428 15.8732 36.3428 17.0926C36.3428 18.312 37.3313 19.3005 38.5507 19.3005Z",
    fill: "#F19D06"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2186 20.4722C2.2186 20.4722 8.21989 21.5585 8.95001 19.3503C9.69795 17.1421 7.48976 16.3942 7.48976 16.3942C7.48976 16.3942 9.53767 15.112 8.9144 13.9901C8.27331 12.8504 5.33499 14.097 5.33499 14.097C5.33499 14.097 6.13635 13.0997 5.17472 12.2984C2.34325 9.96553 -2.2334 20.5435 -2.2334 20.5435L2.2364 20.4722H2.2186Z",
    fill: "#F19D06"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.505825 16.2525C-0.505825 16.2525 1.79141 10.6074 -0.22089 9.43208C-2.23319 8.25675 -3.40852 10.2691 -3.40852 10.2691C-3.40852 10.2691 -4.22769 8.00744 -5.47425 8.38141C-6.7208 8.77318 -6.09752 11.9074 -6.09752 11.9074C-6.09752 11.9074 -6.89888 10.9101 -7.87832 11.6937C-10.7276 13.9909 -1.32499 20.6511 -1.32499 20.6511L-0.48801 16.2525H-0.505825Z",
    fill: "#F19D06"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0.990304 20.4893C0.990304 20.4893 5.33546 21.2729 5.8697 19.6702C6.40394 18.0674 4.80122 17.5332 4.80122 17.5332C4.80122 17.5332 6.29709 16.6072 5.83408 15.788C5.37107 14.9689 3.23411 15.8593 3.23411 15.8593C3.23411 15.8593 3.82178 15.1469 3.10946 14.5593C1.06154 12.8675 -2.26855 20.5428 -2.26855 20.5428L0.972501 20.4893H0.990304Z",
    fill: "#F19D06"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.68399 17.1425C-0.68399 17.1425 1.15024 12.637 -0.452477 11.711C-2.0552 10.785 -2.99903 12.3699 -2.99903 12.3699C-2.99903 12.3699 -3.65792 10.5535 -4.65517 10.8741C-5.65241 11.1768 -5.15379 13.6877 -5.15379 13.6877C-5.15379 13.6877 -5.79488 12.8864 -6.57843 13.5274C-8.85785 15.3617 -1.36069 20.6684 -1.36069 20.6684L-0.68399 17.1603V17.1425Z",
    fill: "#F19D06"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.95071 24.2113C-0.95071 24.2113 -0.843862 30.3016 1.45337 30.6043C3.7684 30.9071 4.07114 28.592 4.07114 28.592C4.07114 28.592 5.72728 30.355 6.70672 29.518C7.68616 28.6811 5.90536 26.0277 5.90536 26.0277C5.90536 26.0277 7.02727 26.6331 7.63274 25.5112C9.36011 22.288 -1.89453 19.8483 -1.89453 19.8483L-0.95071 24.2113Z",
    fill: "#F19D06"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.18296 23.1784C-1.18296 23.1784 -1.11173 27.8263 0.651257 28.0578C2.41425 28.2893 2.64575 26.5263 2.64575 26.5263C2.64575 26.5263 3.91012 27.8797 4.65805 27.2386C5.40599 26.5975 4.05259 24.5674 4.05259 24.5674C4.05259 24.5674 4.90737 25.0304 5.37037 24.1756C6.68816 21.7181 -1.91309 19.8483 -1.91309 19.8483L-1.18296 23.1784Z",
    fill: "#F19D06"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25662 25.9742L-1.75293 19.8483L3.57166 23.8017",
    stroke: "#F19D06",
    strokeWidth: 0.142464,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17811 18.9596L-1.14648 19.4226L2.68223 16.235",
    stroke: "#F19D06",
    strokeWidth: 0.142464,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.75206 22.7159C-0.168612 22.7159 1.11503 21.4323 1.11503 19.8488C1.11503 18.2654 -0.168612 16.9818 -1.75206 16.9818C-3.33551 16.9818 -4.61914 18.2654 -4.61914 19.8488C-4.61914 21.4323 -3.33551 22.7159 -1.75206 22.7159Z",
    fill: "#66C0CB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.75224 22.0237C-0.55236 22.0237 0.420336 21.051 0.420336 19.8512C0.420336 18.6513 -0.55236 17.6786 -1.75224 17.6786C-2.95212 17.6786 -3.9248 18.6513 -3.9248 19.8512C-3.9248 21.051 -2.95212 22.0237 -1.75224 22.0237Z",
    fill: "#66C0CB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.903 38.1896C14.903 38.1896 24.6706 33.5901 24.6533 37.4661C24.5844 46.0795 16.8669 45.0459 16.8669 45.0459C16.8669 45.0459 18.5895 47.0958 16.8669 48.1467C14.6963 49.4731 11.6816 43.8228 11.6816 43.8228L14.8858 38.1896H14.903Z",
    fill: "#66C0CB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6535 37.468C24.6535 36.3483 23.8611 35.9348 22.7069 35.9176C22.7586 36.0726 22.7758 36.2449 22.7758 36.4344C22.7413 41.9297 19.3477 43.1873 17.2288 43.4457C16.5569 43.5318 16.1091 44.1864 16.2469 44.841C16.3502 45.3578 16.2469 45.9263 15.575 46.3225C14.3175 47.0805 12.7843 45.3751 11.7852 43.9452C12.2675 44.8066 14.9204 49.32 16.9015 48.1141C18.6069 47.0805 16.9015 45.0133 16.9015 45.0133C16.9015 45.0133 24.619 46.0469 24.688 37.4336L24.6535 37.468Z",
    fill: "#167A8A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9978 41.1366C23.9978 41.1022 24.0151 41.085 24.0323 41.0505C24.084 40.9127 24.1356 40.7577 24.1873 40.6026C24.2218 40.482 24.2562 40.3787 24.2907 40.2409C24.5146 39.4484 24.6352 38.5182 24.6524 37.4501C24.6524 37.3812 24.6524 37.3295 24.6524 37.2606C24.6524 37.2434 24.6524 37.2262 24.6524 37.209C24.6524 37.1745 24.6524 37.1228 24.6524 37.0884C24.6524 37.0711 24.6524 37.0539 24.6524 37.0195C24.6524 36.985 24.6524 36.9506 24.618 36.9161C24.618 36.8989 24.618 36.8816 24.6008 36.8644C24.6008 36.83 24.5835 36.7955 24.5663 36.7783C24.5663 36.7783 20.9315 45.8223 12.3354 42.756L11.7324 43.8068C11.7324 43.8068 11.7841 43.8929 11.8702 44.048C11.8875 44.0824 11.9047 44.1169 11.9219 44.1513C11.9391 44.1858 11.9736 44.2202 11.9908 44.2719C12.008 44.3064 12.0425 44.358 12.077 44.4097C12.1114 44.4614 12.1286 44.5131 12.1631 44.5648C12.1975 44.6164 12.232 44.6681 12.2665 44.7198C12.3009 44.7715 12.3354 44.8232 12.3698 44.8921C12.3698 44.8921 12.3698 44.8921 12.3698 44.9093C12.4043 44.961 12.4387 45.0299 12.4732 45.0816C12.4732 45.0816 12.4732 45.0988 12.4904 45.116C12.5248 45.1677 12.5593 45.2366 12.611 45.2883C12.611 45.2883 12.611 45.3055 12.6282 45.3227C12.6627 45.3916 12.7143 45.4433 12.7488 45.5122C12.7488 45.5122 12.7488 45.5122 12.7488 45.5295C12.8005 45.5984 12.8349 45.65 12.8866 45.7189C12.9383 45.7879 12.9727 45.8568 13.0244 45.9084C13.0244 45.9084 13.0244 45.9084 13.0417 45.9257C13.0933 45.9946 13.1278 46.0463 13.1795 46.1152C13.1795 46.1152 13.1967 46.1324 13.2139 46.1496C13.2656 46.2185 13.3173 46.2702 13.3517 46.3391C13.3517 46.3391 13.369 46.3563 13.3862 46.3736C13.4379 46.4425 13.4895 46.4941 13.5412 46.5631C13.5412 46.5631 13.5412 46.5803 13.5585 46.5975C13.6101 46.6664 13.6618 46.7181 13.7135 46.787C13.7652 46.8559 13.8169 46.9076 13.8858 46.9593C13.8858 46.9593 13.8858 46.9593 13.903 46.9765C13.9547 47.0282 14.0063 47.0971 14.0753 47.1488C14.0753 47.1488 14.0925 47.166 14.1097 47.1832C14.1614 47.2349 14.2131 47.2866 14.282 47.3383C14.282 47.3383 14.2992 47.3555 14.3164 47.3727C14.3681 47.4244 14.4198 47.4761 14.4887 47.5277C14.4887 47.5277 14.5059 47.5277 14.5231 47.545C14.5748 47.5967 14.6437 47.6483 14.6954 47.6828C14.7471 47.7345 14.816 47.7689 14.8677 47.8034C14.9194 47.8378 14.9883 47.8895 15.0399 47.924C15.0399 47.924 15.0572 47.924 15.0744 47.924C15.1261 47.9584 15.195 47.9929 15.2467 48.0273C15.2467 48.0273 15.2639 48.0273 15.2811 48.0273C15.3328 48.0618 15.4017 48.079 15.4534 48.1135C15.4534 48.1135 15.4706 48.1135 15.4878 48.1135C15.5395 48.1307 15.6084 48.1651 15.6601 48.1824C15.6601 48.1824 15.6601 48.1824 15.6773 48.1824C15.729 48.1824 15.7979 48.2168 15.8496 48.2168C15.9013 48.2168 15.9702 48.2168 16.0219 48.234C16.0219 48.234 16.0219 48.234 16.0391 48.234C16.0908 48.234 16.1597 48.234 16.2114 48.234C16.2114 48.234 16.2286 48.234 16.2458 48.234C16.2975 48.234 16.3492 48.234 16.4181 48.1996C16.4181 48.1996 16.4353 48.1996 16.4525 48.1996C16.5042 48.1996 16.5731 48.1651 16.6248 48.1479C16.6248 48.1479 16.6248 48.1479 16.642 48.1479C16.6937 48.1307 16.7626 48.0962 16.8143 48.0618C18.5197 47.0282 16.8143 44.961 16.8143 44.961C16.8143 44.961 18.1924 45.1505 19.7773 44.7198C19.8979 44.6853 20.0185 44.6509 20.139 44.6164C20.3802 44.5303 20.6214 44.4442 20.8626 44.3408C21.0521 44.2547 21.2243 44.1685 21.3966 44.0652C21.6895 43.8929 21.9823 43.6862 22.2752 43.445C22.5508 43.2038 22.8264 42.9282 23.0676 42.6181C23.1709 42.4976 23.2571 42.3597 23.3604 42.2219C23.4638 42.0841 23.4466 42.0841 23.4983 42.0152C23.6705 41.7396 23.8256 41.4295 23.9634 41.085L23.9978 41.1366Z",
    fill: "#66C0CB"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7821 38.1207C14.7821 38.1207 14.1447 27.3368 10.7682 29.2145C3.24018 33.4006 7.83971 39.6711 7.83971 39.6711C7.83971 39.6711 5.22126 39.1543 5.1179 41.1354C4.99731 43.6849 11.3884 43.6333 11.3884 43.6333L14.7993 38.1207H14.7821Z",
    fill: "#66C0CB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7511 29.2141C11.7331 28.6801 12.4738 29.1797 13.0423 30.196C12.8872 30.2305 12.715 30.2822 12.5427 30.3855C7.73646 33.0557 8.25326 36.6216 9.04569 38.6199C9.30409 39.2573 8.94233 39.9464 8.28771 40.1531C7.78814 40.3081 7.34024 40.6871 7.30579 41.4451C7.23688 42.9093 9.47635 43.4434 11.199 43.6501C10.1999 43.6501 4.98019 43.4606 5.08355 41.1522C5.18691 39.1539 7.80536 39.688 7.80536 39.688C7.80536 39.688 3.20584 33.4002 10.7339 29.2314L10.7511 29.2141Z",
    fill: "#167A8A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3179 40.8945C13.3179 40.8945 16.5221 38.8617 19.0544 39.2579C19.0544 39.2579 15.7813 39.568 13.0078 41.5146C13.0078 41.5146 14.7649 40.7567 16.3326 41.239C16.3326 41.239 13.7141 41.4802 12.6633 42.2037C12.6633 42.2037 13.9725 42.0831 14.7649 42.5482C14.7649 42.5482 13.2834 42.3071 12.336 42.6516C12.336 42.6516 13.0423 43.0995 13.8175 43.3407C13.8175 43.3407 12.715 43.3579 12.1465 43.0306",
    fill: "#167A8A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0762 40.7567C13.0762 40.7567 13.3346 36.9841 11.7669 34.9341C11.7669 34.9341 13.0589 37.9488 12.6799 41.3252C12.6799 41.3252 12.5077 39.413 11.3363 38.2761C11.3363 38.2761 12.3699 40.6878 12.232 41.9626C12.232 41.9626 11.7152 40.7567 10.9228 40.2744C10.9228 40.2744 11.8531 41.4458 11.9909 42.4621C11.9909 42.4621 11.2673 42.0487 10.6816 41.4802C10.6816 41.4802 11.1812 42.4449 11.7497 42.7895",
    fill: "#167A8A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 41.2905C12.3701 43.2716 11.1815 44.7531 10.8886 44.5808C10.613 44.4085 11.3365 42.6686 12.5079 40.6876C13.6794 38.7065 14.868 37.225 15.1609 37.3973C15.4365 37.5695 14.713 39.3094 13.5416 41.2905Z",
    fill: "#193742"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9893 39.2043C14.575 37.9984 15.4018 36.3619 15.8497 35.1216C16.4699 33.4506 19.1573 26.5427 16.0737 26.3359C15.2296 26.3704 14.7472 27.404 14.7645 28.162C14.7645 28.317 14.8161 28.472 14.885 28.5237C15.1262 28.7649 14.7472 29.0922 14.5405 28.851C14.2132 28.4376 14.2993 27.9897 14.3855 27.559C14.6783 26.3704 15.7981 25.4574 16.9695 26.2154C19.1056 27.6107 16.7283 33.2611 15.9703 35.1388C15.488 36.3619 14.6094 37.9984 14.0065 39.1871L13.9893 39.2043Z",
    fill: "#193742"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0416 39.2215C14.7996 38.119 15.7988 36.5686 16.6429 35.5523C18.0727 33.8124 19.5542 32.0552 21.4663 30.8149C22.1382 30.4187 22.9134 30.0397 23.723 30.2637C24.326 30.4704 24.8428 31.0044 24.86 31.659C24.9117 32.572 23.8609 33.9329 22.8617 33.7779C22.5516 33.709 22.655 33.2439 22.9651 33.3128C23.5336 33.3989 24.1709 32.6409 24.3604 32.1414C24.6533 31.4868 24.2398 30.8149 23.6025 30.591C22.9306 30.3842 22.2071 30.7116 21.6042 31.0561C19.692 32.2275 18.176 33.9329 16.729 35.6039C15.8504 36.5859 14.7996 38.119 14.0244 39.1871L14.0416 39.2215Z",
    fill: "#193742"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29423_6777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringBanner);
export default __webpack_public_path__ + "static/media/springBanner.e7d489e25d346813b02d334e901d4857.svg";
export { ForwardRef as ReactComponent };